import { Component, Input } from '@angular/core';

import { PaymentCreditcardComponent } from '../../payment-creditcard.component';

/**
 * "the_portrait" view of /payment-creditcard.
 *
 * Uses <qrcode>, whose colours are configurable, but is still rendered dark-on-light on a
 * white plate to match the other methods and to keep every code scannable.
 */
@Component({
  selector: 'app-payment-creditcard-portrait',
  templateUrl: './payment-creditcard-portrait.component.html',
  styleUrls: ['./payment-creditcard-portrait.component.scss']
})
export class PaymentCreditcardPortraitComponent {

  @Input() host!: PaymentCreditcardComponent;

}
